/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const progressTokens = {
  CoreBackgroundDefault: '#ebecec',
  CoreBackgroundShimmerPrimary: '#dedfdf',
  CoreBackgroundShimmerSecondary: '#ebecec',
  CoreColorLegend: '#656b6b',
  CoreColorGray: '#c4c4c4', // gray-darker color
  CoreSizeBarSmall: '9px',
  CoreSizeBarLarge: '13px',
  CoreSizeCapSmall: '4.5px',
  CoreSizeCapLarge: '6.5px',
  CoreSizeIconSmall: '6px',
  CoreSizeIconLarge: '12px',
  CoreBorderRadiusDefault: '24px',
  CoreBorderRadiusNone: '0px',
  CoreFontSizeBaseDefault: '14px',
  CoreFontWeightBaseDefault: '400',
  CoreFontLeadingBaseDefault: '24px',
} as const;
